module.exports = __webpack_public_path__ + "img/qrcode2.a6098f9e.png";